<template>
    <div>
        <div class='explain'>
            <s-l id="verifiedByCode">L'application a besoin de s'assurer que votre email {{this.$store.getters.getUser.email}} vous appartient. Vous avez dû revevoir un code dans votre messagerie.<br/>Attention il est peut être dans vos courriers indésirables</i></s-l>
        </div>
        <div class='labelInput'>
            <s-l id="verifiedLabelInput">Veuillez le saisir le code que vous avez reçu : </s-l>
            <br/>
            <PincodeInput
                v-model="code"
                placeholder="0"
            /><br/>
            <div class="error" v-show="error">
                <s-l id="errorCode">Votre code n'est pas le bon, veuillez vérifier le dernier code reçu. Vous pouvez en renvoyer un autre.</s-l>
            </div>
            <br/>
            <s-button icon="check" label="Valider" @onclick="valider" theme="is-success"/>
            <br/>
            <br/>
            <s-button icon="paper-plane" label="Réenvoyer un code" @onclick="sendCode" theme="is-primary"/>
            <s-info id="verifiedSendCode" :open="modalSend" @close="modalSend=false" :close="true">Un nouveau code vous a été envoyé</s-info>
        </div>
        
    </div>
</template>
<style scoped>
    .error {
        font-size: 12px;
        color: red;
    }
    .explain {
        font-size: 20px;
        font-weight: bolder;
        text-align: center;
        margin-top: 50px;
        margin-left: 10px;
        margin-right: 10px;
    }
    .labelInput {
        font-size: 20px;
        font-weight: bolder;
        text-align: center;
        margin-left: 10px;
        margin-right: 10px;
    }
</style>
<script>
import firebase from "firebase";
import user_fct from '@/firebase/user'
export default {
    data() {
        return {
            code: "",
            error: false,
            modalSend: false
        }
    },
    mounted() {
        if (firebase.auth().currentUser.emailVerified) {
            this.$router.push({name: "club"})
                        .then(()=>{})
                        .catch(error=>{
                        
            });
        }
    },
    methods: {
        valider() {
            
            this.error = false;
            const functions = firebase.app().functions('europe-west1');
            
            this.openWaiting = true;
            const params =  {
                code: this.code
            }
            functions.httpsCallable("emailVerified")(params).then(res=>{
                
                if (res.data) {
                        location.reload();
                    }
                else
                    this.error = true;
            })
            
        },
        async sendCode() {
            const currentUser = firebase.auth().currentUser;
            await user_fct.object.sendCode(currentUser);
            this.modalSend = true;
        }
    }
}
</script>